import { Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule, DatePipe, DecimalPipe, NgFor } from '@angular/common';
import { Itinerary, Plan } from '@features/planification-map/components/route-form/models/routeRequestResults.model';
import { LegBanner } from './components/leg-banner/leg-banner.component';
import { ShowDurationDirective } from '@shared/directives/show-duration.directive';
import { MatIconModule } from '@angular/material/icon';
import { CoreService } from '@core/services';
import { TranslocoPipe } from '@ngneat/transloco';

@Component({
  selector: 'app-route-itinerary-banners',
  standalone: true,
  imports: [CommonModule, NgFor, LegBanner, DatePipe, ShowDurationDirective, MatIconModule, DecimalPipe, TranslocoPipe],
  templateUrl: './route-itinerary-banners.component.html',
  styleUrls: ['./route-itinerary-banners.component.scss']
})
export class RouteItineraryBannersComponents implements OnInit{

  @Input({required: true}) optionPlan!: Plan;
  public coreService = inject(CoreService);

  public indexSelected = this.coreService.itineraryIndexSelected;
  private itinerarySelected = this.coreService.itinerarySelected;

  public ngOnInit(): void {
    if (this.optionPlan.itineraries.length > 0 && this.indexSelected() === -1) {
      this.indexSelected.set(0);
      this.itinerarySelected.set(this.optionPlan.itineraries[0]);
      this.coreService.selectItinerary(this.optionPlan.itineraries[0], false);
    }     
  }


  public selectItinerary(itinerary: Itinerary, index:number) {
    this.coreService.selectItinerary(itinerary);
    this.indexSelected.set(index);
    this.itinerarySelected.set(itinerary);
  }
}
